import type { Components, Theme } from "@mui/material";

declare module "@mui/material/Switch" {
  interface SwitchPropsColorOverrides {
    cyan: true;
    green: true;
    yellow: true;
    orange: true;
    magenta: true;
    purple: true;
    dark: true;
  }
}

export const covestroMuiSwitch: Components<Theme>["MuiSwitch"] = {
  defaultProps: {},
  styleOverrides: {},
};
